import { isUsingStaticRendering, observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import GlobalState from '../../../../stores/GlobalState'
import { CountriesStore } from '../../career/CoopPop'
import './index.scss'

const CountrySelect = observer(
  ({
    setState,
    showCode = true,
  }: {
    setState: (value: any) => void
    showCode?: boolean
  }) => {
    const ref = useRef<any>(null)
    const content = {
      placeholder: GlobalState.currentLocale.lang.includes('ру')
        ? 'Поиск...'
        : GlobalState.currentLocale.lang.includes('En')
        ? 'Search...'
        : 'Пошук...',
    }
    const [countries, setCountries] = useState<any>(null)
    const [value, setValue] = useState('')

    const getCountriesByName = (name: string) => {
      return;
      let res: any = Array()

      if (GlobalState.currentLocale.lang.includes('En')) {
        CountriesStore.list?.en?.forEach((e: any) => {
          if (
            e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
          ) {
            res.push(e)
          }
        })

        if (!res.length) {
          CountriesStore.list?.ru?.forEach((e: any) => {
            if (
              e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
            ) {
              res.push(e)
            }
          })
        }
        if (!res.length) {
          CountriesStore.list?.uk?.forEach((e: any) => {
            if (
              e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
            ) {
              res.push(e)
            }
          })
        }
      }

      if (GlobalState.currentLocale.lang.includes('ру')) {
        CountriesStore.list?.ru?.forEach((e: any) => {
          if (
            e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
          ) {
            res.push(e)
          }
        })

        if (!res.length) {
          CountriesStore.list?.en?.forEach((e: any) => {
            if (
              e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
            ) {
              res.push(e)
            }
          })
        }
        if (!res.length) {
          CountriesStore.list?.uk?.forEach((e: any) => {
            if (
              e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
            ) {
              res.push(e)
            }
          })
        }
      }

      if (GlobalState.currentLocale.lang.includes('Ук')) {
        CountriesStore.list?.uk?.forEach((e: any) => {
          if (
            e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
          ) {
            res.push(e)
          }
        })

        if (!res.length) {
          CountriesStore.list?.en?.forEach((e: any) => {
            if (
              e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
            ) {
              res.push(e)
            }
          })
        }
        if (!res.length) {
          CountriesStore.list?.ru?.forEach((e: any) => {
            if (
              e.country.toLocaleLowerCase().includes(name.toLocaleLowerCase())
            ) {
              res.push(e)
            }
          })
        }
      }

      setCountries(res)
    }

    useEffect(() => {
      if (!CountriesStore.list) return
      const list = GlobalState.currentLocale.lang.includes('En')
        ? CountriesStore.list?.en.filter((e: any) => e.country == 'Ukraine')
        : GlobalState.currentLocale.lang.includes('ру')
        ? CountriesStore.list?.ru.filter((e: any) => e.country == 'Украина')
        : CountriesStore.list?.uk.filter((e: any) => e.country == 'Україна')

      if (!value.length)
        setCountries(
          list.sort((a: any, b: any) => a.country.localeCompare(b.country)),
        )
      if (value.length >= 3) {
        getCountriesByName(value)
      }
    }, [value, CountriesStore.list])

    const isInside = (e: Event) => {
      if (!ref.current) return false
      if (!(ref.current as any).contains(e.target)) {
        setState(null)
        return
      } else return false
    }

    useEffect(() => {
      if (!ref.current) return
      const parent = document.querySelector('.coop-pop__container')
      if (!parent) {
        const pr = document.querySelector('.login-content2')
        if (!pr) return
        pr.addEventListener('click', (e) => isInside(e))
      } else {
        parent.addEventListener('click', (e) => isInside(e))
      }

      return () => {
        parent && parent.removeEventListener('click', (e) => isInside(e))
      }
    }, [])

    return (
      <section
        className="country-select"
        ref={ref}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          className="country-select__input"
          value={value}
          placeholder={content.placeholder}
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="country-select__list">
          <div className="country-select__scroll">
            {countries &&
              countries?.map((c: any, i: number) => (
                <div
                  className="country-select__item"
                  key={i}
                  onClick={() => {
                    setState({
                      country: c.country,
                      number: c.code,
                      flag: c.flag,
                    })
                  }}
                >
                  <div className="country-select__item-icon">
                    <img src={c?.flag} />
                  </div>

                  <div className="country-select__item-text">
                    {c.country}{' '}
                    {showCode && (
                      <div className="country-select__item-num">{c.code}</div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    )
  },
)

export default CountrySelect
